export default __webpack_public_path__ + "static/media/abi-logo-square.ffc33f98.png";